/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

@mixin unitModifier($display) {
  .input--label + .unit {
    display: $display;
  }
}

.input {
  // hide the default arrows so we can add custom styles
  &--number {
    -moz-appearance: textfield;
    padding-right: 0;
    .button {
      padding: 0;
      background-color: transparent;
    }

    .unit {
      color: var(--chart-300-icon-buttons);
      padding: var(--spacer) calc(var(--spacer) / 2) var(--spacer) 0;
      font-family: var(--font-family-secondary);
    }

    .unit-left {
      padding-left: calc(var(--spacer) + 4px);
      order: -1;
    }

    @include unitModifier(none);

    &:focus-within {
      @include unitModifier(block);
    }

    &.floating-label {
      @include unitModifier(block);
    }
  }
}

.number-control {
  display: flex;
  flex-direction: column;
  width: var(--input-btn-width);
  height: 100%;

  &--arrow {
    height: 50%;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--chart-300-icon-buttons);

    &:first-of-type {
      border-radius: 0 3px 0 0;
    }

    &:last-of-type {
      border-radius: 0 0 3px 0;
    }

    &:hover {
      background-color: var(--chart-050-hover);
    }

    &:focus-visible {
      border: 1px solid var(--blue-layout-050-selected);
    }

    &:active {
      background-color: var(--chart-100-pressed);
      border: none;
    }
  }
}

:host([readonly]) {
  .number-control {
    display: none;
  }
}
